/* eslint-disable no-underscore-dangle */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Chip, Menu, MenuItem, ListItemIcon } from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { statusLabels, PUBLISHED, VALIDATED } from "contants";
import SourceActions from "redux-react/actions/sourceActions";
import { updateAsset } from "redux-react/reducers/assetReducer";
import { display } from "redux-react/reducers/snackBarReducer";
import PublicIcon from "@mui/icons-material/Public";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const statusIcons = {
	[PUBLISHED]: <PublicIcon fontSize="small" />,
	[VALIDATED]: <TaskAltIcon fontSize="small" />
};

const getStatusColor = value => {
	if (value === "draft") return "warning";
	if (value === "published") return "success";
	return "info";
};

/**
 * @param {Object} param0 - Component props.
 * @param {obj} param0.value - The object that contains row original value
 * @param {function} param0.t - The translation function used to get the localized label for the status.
 * @param {boolean} param0.disabled - Indicates if the `Chip` component should be disabled.
 * @returns {JSX.Element} The rendered `Chip` component.
 */
const Status = ({ value: original, t, disabled }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const dispatch = useDispatch();
	const open = Boolean(anchorEl);
	const { _id, status } = original;

	const handleClickListItem = e => {
		e.stopPropagation();
		e.preventDefault();
		setAnchorEl(e.currentTarget);
	};

	const handleMenuItemClick = selected => {
		setAnchorEl(null);
		const onSuccessCallback = res => {
			dispatch(
				display({
					type: "success",
					message: t("SOURCES.FILES.updateSuccess")
				})
			);
			dispatch(updateAsset({ ...res, id: res._id }));
		};
		dispatch(SourceActions.updateAsset(_id, { status: selected }, onSuccessCallback));
	};

	const handleClose = e => {
		e.stopPropagation();
		e.preventDefault();
		setAnchorEl(null);
	};

	const label = t(`ASSETS.STATUS.${status}`, { defaultValue: status });

	return (
		<>
			<Chip
				label={label}
				size="small"
				color={getStatusColor(status)}
				variant="outlined"
				onClick={handleClickListItem}
				icon={statusIcons[status] || <EditNoteIcon fontSize="small" />}
				disabled={disabled}
				sx={{ width: "100%" }}
			/>
			<Menu
				id="lock-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				slotProps={{
					"aria-labelledby": "lock-button",
					role: "listbox"
				}}
			>
				{statusLabels.map(option => (
					<MenuItem
						key={option.value}
						disabled={option.value === status}
						selected={option.value === status}
						onClick={e => {
							e.stopPropagation();
							e.preventDefault();
							handleMenuItemClick(option.value);
						}}
					>
						<ListItemIcon>
							{statusIcons[option.value] || <EditNoteIcon fontSize="small" />}
						</ListItemIcon>
						{t(option.label)}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default React.memo(Status);
